"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpServiceResponse = void 0;
/**
 * @category HTTP
 */
var HttpServiceResponse = /** @class */ (function () {
    function HttpServiceResponse(request, statusCode, url, responseText, headers, options) {
        this.request = request;
        this.statusCode = statusCode;
        this.url = url;
        this.responseText = responseText;
        this.headers = headers;
        var text = responseText;
        // Maybe we should check for application/json content-type in response as well?
        if (text && typeof text === 'string' && text.length > 0) {
            try {
                if (text && text.length > 0) {
                    this.response = JSON.parse(text);
                }
            }
            catch (e) {
                this.response = text;
                if (options.responseContentType === 'json') {
                    console.error("We detected an error in `httpService` which suppose to get JSON-format data, while the server-side returned none-json content. If the none-JSON content is desired, please specific `responseContentType: 'text'` when you call `httpService`.", options, 'response = ', text);
                }
            }
        }
    }
    Object.defineProperty(HttpServiceResponse.prototype, "ok", {
        get: function () {
            return this.statusCode >= 200 && this.statusCode <= 299;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpServiceResponse.prototype, "redirected", {
        get: function () {
            return this.statusCode >= 300 && this.statusCode <= 399;
        },
        enumerable: false,
        configurable: true
    });
    return HttpServiceResponse;
}());
exports.HttpServiceResponse = HttpServiceResponse;
//# sourceMappingURL=HttpServiceResponse.js.map